import {
  Link,
  type HistoryState,
  type LinkProps,
} from "@tanstack/react-router";

import { navLinkStyles } from ".";

interface NavItemLocation {
  pathname: string;
  search?: LinkProps["search"];
  state?: LinkProps["state"];
}

export interface NavItemProps {
  href: string | NavItemLocation;
  label: string;
  replace?: boolean;
}

const resolveLinkTarget = (href: string | NavItemLocation) => {
  if (typeof href === "string") {
    return { to: href as LinkProps["to"] };
  }

  return {
    to: href.pathname as LinkProps["to"],
    search: href.search,
    state: href.state as HistoryState,
  };
};

export const NavItem = ({ label, href, replace }: NavItemProps) => {
  const { to, search, state } = resolveLinkTarget(href);
  return (
    <li>
      <Link
        to={to}
        search={search}
        state={state as HistoryState}
        replace={replace}
        className={navLinkStyles.className}
        activeProps={{ className: navLinkStyles.activeClassName }}
        activeOptions={{
          exact: true,
          includeSearch: false,
        }}
      >
        {label}
      </Link>
    </li>
  );
};
